import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'

import { useStores } from '@trivie/core'

import { FileUpload } from '../components/file-upload'
import { Text } from '@trivie/ui-web/components/text'
import { ResourceApi } from '@trivie/core/src/services/api-objects/ResourceApi'
import { Resource } from '@trivie/core/src/models/Resource'
import { color } from '@trivie/ui-web/theme'

interface UploadResourceTabProps {
  quiz?: any
  onUpload?: any
  standalone?: any
  topic?: any
  card?: boolean
}

export const UploadResourceTab = observer((props: UploadResourceTabProps) => {
  const { standalone, topic, quiz, card, onUpload } = props
  const { resourceStore, utilityStore } = useStores()
  const { getMimeTypes, mediaMimetypes, mercuryMimetypes, allMimetypes } = utilityStore
  const { addResource, getAvailableResources, availableResources } = resourceStore

  const [file, setFile] = useState<File | null>(null)
  const [progress, setProgress] = useState<any>(undefined)
  const [error, setError] = useState(false)

  useEffect(() => {
    getMimeTypes()
  }, [])

  const handleFile = async (f: File | null) => {
    setFile(f)

    if (!f) {
      throw new Error(`Can't upload undefined file`)
    } else if (!f.type || !allMimetypes.includes(f.type)) {
      setError(true)
      return
    }

    setProgress({ loaded: 0, total: 100 })

    const result = (await addResource((currentProgress: any) => setProgress(currentProgress), {
      file: f,
      title: f.name,
      file_size: f.size,
      mime_type: f.type,
    })) as any

    if (!result) {
      setError(true)
      return
    } else {
      const r = await ResourceApi.getSourceDetails(result.source_id)
      if (r) {
        getAvailableResources().then(() => {
          const resource = Resource.create({
            ...r.data,
            is_required: false,
            identityBreaker: Math.random() * 999999999,
          })
          if (resource) {
            if (standalone) {
              onUpload(resource)
            } else {
              quiz.setResourceDocument(undefined)
              if (resource) {
                quiz.setMercuryResource(resource)
                quiz.addResource(resource)
                if (Boolean(onUpload)) {
                  onUpload()
                  setFile(null)
                }
              }
            }
          }
        })
      }
    }
  }

  return (standalone || (!topic && !quiz)) && !card ? (
    <>
      <FileUpload
        accept={allMimetypes.join(';')}
        file={file}
        label="Files must be under 100mb"
        onChange={handleFile}
        style={{ paddingTop: 0, paddingBottom: 0, height: 86 }}
        progress={progress}
        showSize
        error={error ? 'File could not be uploaded' : ''}
      />
      {error && (
        <Text component="p" sx={{ mt: 2, color: color.red }} variant="body2">
          The file failed to upload. Try refreshing the page and uploading again. If this still does
          not work, please email&nbsp;
          <a href="mailto:support@trivie.com">support@trivie.com</a>
          &nbsp;for assistance.
        </Text>
      )}
    </>
  ) : (
    <>
      <FileUpload
        accept={card ? mediaMimetypes.join(';') : mercuryMimetypes.join(';')}
        file={file}
        onChange={handleFile}
        style={{ paddingTop: 0, paddingBottom: 0, height: 86 }}
        progress={progress}
        showSize
        error={error ? 'File could not be uploaded' : ''}
      />
      {error && (
        <Text component="p" sx={{ mt: 2, color: color.red }} variant="body2">
          The file failed to upload. Try refreshing the page and uploading again. If this still does
          not work, please email&nbsp;
          <a href="mailto:support@trivie.com">support@trivie.com</a>
          &nbsp;for assistance.
        </Text>
      )}
    </>
  )
})
